module.exports = __webpack_public_path__ + "static/img/function-5.3500db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/function-5.png
// module id = EVtN
// module chunks = 0